module.exports = __webpack_public_path__ + "img/logo2.ebe11400.png";